.wheelContainer {
	position: relative;
	&:before {
		content: '';
		width: 0px;
		height: 0px;
		border-style: solid;
		border-width: 3rem 1rem 0;
		border-color: var(--color-default) transparent transparent transparent;
		position: absolute;
		top: 0;
		left: 50%;
		z-index: 1;
		transform: translateX(-50%);
	}
	&:after {
		content: '';
		z-index: 1;
		border-radius: 50%;
		width: 5%;
		height: 5%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 1;
		background-color: var(--bg-default);
		border: 0.25rem solid var(--bg-default);
		box-shadow:
			0 0 2rem #00000026,
			inset 0 0 1rem #00000026;
	}
}

.wheel {
	all: unset;
	aspect-ratio: 1 / 1;
	container-type: inline-size;
	direction: ltr;
	display: grid;
	place-content: center start;
	width: 45vw;
	border: 0.25rem solid var(--bg-default);
	border-radius: 50%;
	overflow: hidden;
	box-shadow:
		0 0 2rem #00000026,
		inset 0 0 1rem #00000026;
}
